// This functions are temporary, gonna get removed once we receive seo content from panel and use HeadTag component

const categorySlugToSeoContentMapper: Record<string, string> = {
    'felt-cases': 'Felt eyeglasses cases with affordable prices and its wide selection are on this page. Start reviewing felt cases.',
    'cleaning-cloths': 'Eyeglass cleaning cloth with affordable prices and its wide selection are on this page. Start reviewing cleaning cloth.',
    'tote-bags': 'Tote bag models with affordable prices and its wide selection are on this page. Start reviewing tote bags in various color options.',
    'lens-sprays-and-wipes': 'Lens Spray & Wipe products with affordable prices and its wide selection are on this page.',
    'pin-garages': 'They’re only little but they make a huge difference!! Be bold, never boring - with a set of 10 colourful pins to mix and match your look.',
    'eye-care': 'Maintaining healthy eyes is vital for well-being. Our eye care products offer solutions for all needs, ensuring comfort and hydration. Explore our range of eyelid cleaning foams, wipes, lens solutions, dry eye drops, sprays, and masks, tailored to support optimal eye health.'
}

export const getSeoContentByCategorySlug = (productName: string) => {

    if (categorySlugToSeoContentMapper[productName] == null) {
        return productName;
    }

    return categorySlugToSeoContentMapper[productName];
}

const categorySlugToSeoTitleMapper: Record<string, string> = {
    'felt-cases': 'Felt Eyeglasses Cases',
    'cleaning-cloths': 'Eyeglass Cleaning Cloth & Glass Cleaners',
    'tote-bags': 'Tote Bags',
    'lens-sprays-and-wipes': 'Lens Sprays & Wipes',
    'pin-garages': 'Pin Garages',
    'eye-care': 'Eye Care Products for Optimal Eye Health',
    'glasses-straps-and-clips': 'Glasses Straps & Clips',
    'flex-accessory-clips': 'Flex Accessory Clips',
    'glasses-clips': 'Glasses Clips',
    'glasses-straps': 'Glasses Straps'
}

export const getSeoTitleByCategorySlug = (productName: string) => {
    console.log(productName, 'productName');
    if (categorySlugToSeoTitleMapper[productName] == null) {
        return productName;
    }

    return categorySlugToSeoTitleMapper[productName];
}


const imageAltTexts: any = {
    au: "A close-up of a hand holding a contact lens on the tip of the index finger. It highlights the delicate nature of handling contact lenses in Australia.",
    international: "Close-up of a hand carefully holding contact lenses on the tip of a finger, ready for application.",
    ca: "A hand holding a single contact lens on the tip of a finger illustrates the use of contact lenses in Canada.",
};

export const getContactLensAltImageText = (countryCode: any) => {
    if (imageAltTexts[countryCode] == null || countryCode == 'us') {
        return imageAltTexts['international'];
    }
    return imageAltTexts[countryCode];
}
